import React from "react";
import _ from "lodash";

import { 
    Row,
    Col,
    Form,
} from "react-bootstrap-v5";


import RSuiteTagInput from '../../../components/OLD/TagsInput/RSuiteTagInput';
import RTextEditor from '../../../components/OLD/RichTextEditor/RTextEditor.jsx';
import DraggableListByChildren from '../../../components/draggableList/DraggableListByChildren';

import Utils from "../../../utils/utils";

import { connect } from 'react-redux'
import { clear } from "../../../../setup/redux/actions";
import { dispatchApiCallGet } from '../../../../setup/redux/dispatch/actions'


class ProformaInvoiceForm extends React.Component {
  
    constructor(props) {
        super(props);
    
        this.state = {
            
        };
    }


    bodyEmail = () => {
        let {
            handleChange,
            handleBlur,
            setFieldValue,
            setFieldTouched,
            values,
            errors,
        } = this.props.formOptions;

        return <>
            <Form.Group as={Row} className={'mb-5'}>
                <Form.Label column xs={12} md={3} xl={2}>{this.props.fields.emailSettingsProformaInvoiceSubject.label}</Form.Label>
                <Col xs={12} md={true}>
                    <Form.Control
                        type="text"
                        id={this.props.fields.emailSettingsProformaInvoiceSubject.id}
                        placeholder={this.props.fields.emailSettingsProformaInvoiceSubject.placeholder}
                        value={values.emailSettingsProformaInvoiceSubject}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={!!errors.emailSettingsProformaInvoiceSubject}
                        onFocus={(e) => {
                            this.refLastSelectedInput = 'subject';
                        }}
                    />
                    <Form.Control.Feedback type="invalid">{errors.emailSettingsProformaInvoiceSubject}</Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className={'mb-5'}>
                <Form.Label column xs={12} md={3} xl={2}>{this.props.fields.emailSettingsProformaInvoiceFrom.label}</Form.Label>
                <Col xs={12} md={true}>
                    <Form.Control
                        type="text"
                        id={this.props.fields.emailSettingsProformaInvoiceFrom.id}
                        placeholder={this.props.fields.emailSettingsProformaInvoiceFrom.placeholder}
                        value={values.emailSettingsProformaInvoiceFrom}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={!!errors.emailSettingsProformaInvoiceFrom}
                        onFocus={(e) => {
                            this.refLastSelectedInput = 'from';
                        }}
                    />
                    <Form.Control.Feedback type="invalid">{errors.emailSettingsProformaInvoiceFrom}</Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className={'mb-5'}>
                <Form.Label column xs={12} md={3} xl={2}>{this.props.fields.emailSettingsProformaInvoiceCc.label}</Form.Label>
                <Col xs={12} md={true}>
                    <Form.Group className={'mb-5'}>
                        <Form.Control
                            as = {RSuiteTagInput}
                            isInvalid={!!errors.emailSettingsProformaInvoiceCc}

                            id={this.props.fields.emailSettingsProformaInvoiceCc.id}
                            placeholder={this.props.fields.emailSettingsProformaInvoiceCc.placeholder}
                            value={values.emailSettingsProformaInvoiceCc}
                            isDefault={true}
                            onChange={async (value) => {
                                let arr = [];
                                if(value && value.length > 0){
                                    value.forEach(email => {
                                        let pattern = Utils.emailValidation();
            
                                        if(email.match(pattern) != null){
                                            arr.push(email);
                                        } else {
                                            Utils.toast('You must enter a valid email address', 'error');
                                        }
                                    })
                                }

                                await setFieldValue('emailSettingsProformaInvoiceCc', arr);
                            }}
                            onClean={async () => {
                                await setFieldValue('emailSettingsProformaInvoiceCc', []);
                            }}
                        />
                        <Form.Control.Feedback type="invalid">{errors.emailSettingsProformaInvoiceCc}</Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className={'mb-5'}>
                <Form.Label column xs={12} md={3} xl={2}>{this.props.fields.emailSettingsProformaInvoiceMessagePlainText.label}</Form.Label>
                <Col xs={12} md={true}>
                    <Form.Control
                        as = {RTextEditor}
                        isInvalid={!!errors.emailSettingsProformaInvoiceMessagePlainText}
                        id={this.props.fields.emailSettingsProformaInvoiceMessagePlainText.id}

                        editorState={values.emailSettingsProformaInvoiceMessage}
                        placeholder={this.props.fields.emailSettingsProformaInvoiceMessagePlainText.placeholder}
                        onChange={async (plainText, html, editorState) => {
                            setFieldValue('emailSettingsProformaInvoiceMessagePlainText', plainText);
                            setFieldValue('emailSettingsProformaInvoiceMessageHTML', html);
                            setFieldValue('emailSettingsProformaInvoiceMessage', editorState);
                            setFieldTouched('emailSettingsProformaInvoiceMessage', true);
                        }}
                        onFocus={(e) => {
                            this.refLastSelectedInput = 'message';
                        }}
                    />
                    <Form.Control.Feedback type="invalid">{errors.emailSettingsProformaInvoiceMessagePlainText}</Form.Control.Feedback>
                </Col>
            </Form.Group>
        </>
    }

    body = () => {
        let {
            handleChange,
            handleBlur,
            setFieldValue,
            setFieldTouched,
            values,
            errors,
        } = this.props.formOptions;
        
        return <>
            {this.bodyEmail()}

            <Row className={'mt-20 mb-10'}>
                <Col xs={12} md={2} xxl={1}>Is visible</Col>
                <Col xs={12} md={4} lg={3} xxl={2}>Default label name</Col>
                <Col xs={12} md={true}>New label name</Col>
                <Col xs={12}>
                    <hr />
                </Col>
            </Row>


            <DraggableListByChildren 
                showDragHandle={false}
                droppableId={'proformaInvoiceDroppable'}
                onDragEnd={(items, sourceIndex, destinationIndex) => {
                    if(items && items.length > 0){
                        items.forEach((item, i) => {
                            if(item && item.itemData && item.itemData.length > 0){
                                item.itemData.forEach((itemD, j) => {
                                    setFieldValue(itemD, item.sortOrder);
                                });
                            }
                        });
                    }
                }}
            >
                {/* <Form.Group as={Row} sortOrder={values.proformaInvoiceShowProformaInvoiceSortOrder} itemData={['proformaInvoiceShowProformaInvoiceSortOrder']}> */}
                <Form.Group as={Row} sortOrder={"1"} itemData={['proformaInvoiceShowProformaInvoiceSortOrder']} draggable={false}>
                    <Col xs={12} md={2} xxl={1}>
                        <Form.Check
                            id={this.props.fields.proformaInvoiceShowProformaInvoice.id}
                            label={null}
                            checked={values.proformaInvoiceShowProformaInvoice}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={!!errors.proformaInvoiceShowProformaInvoice}
                            feedback={errors.proformaInvoiceShowProformaInvoice}
                        />
                    </Col>
                    <Form.Label column xs={12} md={4} lg={3} xxl={2}>{this.props.fields.proformaInvoiceLabelProformaInvoice.label}</Form.Label>
                    <Col xs={12} md={true}>
                        <Form.Control
                            type="text"
                            id={this.props.fields.proformaInvoiceLabelProformaInvoice.id}
                            placeholder={this.props.fields.proformaInvoiceLabelProformaInvoice.placeholder}
                            value={values.proformaInvoiceLabelProformaInvoice}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={!!errors.proformaInvoiceLabelProformaInvoice}
                        />
                        <Form.Control.Feedback type="invalid">{errors.proformaInvoiceLabelProformaInvoice}</Form.Control.Feedback>
                    </Col>
                </Form.Group>
                {/* <Form.Group as={Row} sortOrder={values.proformaInvoiceShowMessageToCustomerSortOrder} itemData={['proformaInvoiceShowMessageToCustomerSortOrder']}> */}
                <Form.Group as={Row} sortOrder={"2"} itemData={['proformaInvoiceShowMessageToCustomerSortOrder']} draggable={false}>
                    <Col xs={12} md={2} xxl={1}>
                        <Form.Check
                            id={this.props.fields.proformaInvoiceShowMessageToCustomer.id}
                            label={null}
                            checked={values.proformaInvoiceShowMessageToCustomer}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={!!errors.proformaInvoiceShowMessageToCustomer}
                            feedback={errors.proformaInvoiceShowMessageToCustomer}
                        />
                    </Col>
                    <Form.Label column xs={12} md={4} lg={3} xxl={2}>{this.props.fields.proformaInvoiceLabelMessageToCustomerPlainText.label}</Form.Label>
                    <Col xs={12} md={true}>
                        <Form.Control
                            as = {RTextEditor}
                            isInvalid={!!errors.proformaInvoiceLabelMessageToCustomerPlainText}
                            id={this.props.fields.proformaInvoiceLabelMessageToCustomerPlainText.id}

                            toolbar={{
                                options: ['inline', 'textAlign', 'list'],
                                inline: {
                                    inDropdown: false,
                                    options: ['bold', 'italic', 'underline'],
                                },
                                textAlign: {
                                    options: ['left', 'center', 'right', 'justify'],
                                },
                                list: {
                                inDropdown: false,
                                options: ['unordered', 'ordered'],
                                },
                            }}

                            editorState={values.proformaInvoiceLabelMessageToCustomer}
                            placeholder={this.props.fields.proformaInvoiceLabelMessageToCustomerPlainText.placeholder}
                            onChange={async (plainText, html, editorState) => {
                                setFieldValue('proformaInvoiceLabelMessageToCustomerPlainText', plainText);
                                setFieldValue('proformaInvoiceLabelMessageToCustomerHTML', html);
                                setFieldValue('proformaInvoiceLabelMessageToCustomer', editorState);
                                setFieldTouched('proformaInvoiceLabelMessageToCustomerPlainText', true);
                            }}
                        />
                        <Form.Control.Feedback type="invalid">{errors.proformaInvoiceLabelMessageToCustomerPlainText}</Form.Control.Feedback>
                    </Col>
                </Form.Group>
                {/* <Form.Group as={Row} sortOrder={values.proformaInvoiceShowDisclaimerSortOrder} itemData={['proformaInvoiceShowDisclaimerSortOrder']}> */}
                <Form.Group as={Row} sortOrder={"3"} itemData={['proformaInvoiceShowDisclaimerSortOrder']} draggable={false}>
                    <Col xs={12} md={2} xxl={1}>
                        <Form.Check
                            id={this.props.fields.proformaInvoiceShowFooter.id}
                            label={null}
                            checked={values.proformaInvoiceShowFooter}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={!!errors.proformaInvoiceShowFooter}
                            feedback={errors.proformaInvoiceShowFooter}
                        />
                    </Col>
                    <Form.Label column xs={12} md={4} lg={3} xxl={2}>{this.props.fields.proformaInvoiceLabelFooterPlainText.label}</Form.Label>
                    <Col xs={12} md={true}>
                        <Form.Control
                            as = {RTextEditor}
                            isInvalid={!!errors.proformaInvoiceLabelFooterPlainText}
                            id={this.props.fields.proformaInvoiceLabelFooterPlainText.id}

                            editorState={values.proformaInvoiceLabelFooter}
                            placeholder={this.props.fields.proformaInvoiceLabelFooterPlainText.placeholder}
                            onChange={async (plainText, html, editorState) => {
                                setFieldValue('proformaInvoiceLabelFooterPlainText', plainText);
                                setFieldValue('proformaInvoiceLabelFooterHTML', html);
                                setFieldValue('proformaInvoiceLabelFooter', editorState);
                                setFieldTouched('proformaInvoiceLabelFooterPlainText', true);
                            }}
                        />
                        <Form.Control.Feedback type="invalid">{errors.proformaInvoiceLabelFooterPlainText}</Form.Control.Feedback>
                    </Col>
                </Form.Group>
            </DraggableListByChildren>
        </>
    }

    render() {
        return <Row>
            <Col xs={12} md={10} xl={8}>{this.body()}</Col>
        </Row>
    }
}

const mapDispatchToProps = {
  dispatchApiCallGet,
  clear,
}

export default connect(Utils.mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(ProformaInvoiceForm);
